import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import axios from 'axios';
import ContractItemsHistoryModal from "./ContractItemsHistoryModal";
import FrameworkContractsArticleAmountsModal from "./FrameworkContractsArticleAmountsModal";

export default class FrameworkContractsArticleAmounts extends Component {
    constructor() {
        super();

        this.state = {
            show_modal: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({show_modal: true});
    }

    closeModal() {
        this.setState({show_modal: false});
    }

    render() {
        return (
            <div>
                <Button onClick={this.openModal}
                        bsStyle="primary">
                    <i className="fa fa-pencil"></i> {window.__js_contracts.change_amount}
                </Button>
                <FrameworkContractsArticleAmountsModal
                    id={this.props.framework_contract_id}
                    showModal={this.state.show_modal}
                    closeCallback={this.closeModal}/>
            </div>
        );
    }
}

if (document.getElementById("framework-contracts-article-amounts")) {
    let element = document.getElementById("framework-contracts-article-amounts");
    let csrf_token = element.getAttribute("data-csrf-token");
    let framework_contract_id = element.getAttribute("data-framework-contract-id");

    ReactDOM.render(
        <FrameworkContractsArticleAmounts
            csrfToken={csrf_token}
            framework_contract_id={framework_contract_id}/>,
        element
    );
}